import { Component, Input, OnInit } from '@angular/core';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'calsoft-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {
  displayMrpPrice: any =0;
  unitPrice: string;
  unitSpecialPrice: string;

  constructor(private configService:ConfigServiceService,) { }

  ngOnInit(): void {
     
    if(this.specialPrice==undefined){
      this.specialPrice=0.0;
    }


    this.unitPrice=this.formatIndianCurrency(this.price);

    this.unitSpecialPrice=this.formatIndianCurrency(this.specialPrice);
     
    if(this.data.displayMrpPrice!=undefined){
      this.displayMrpPrice=this.data.displayMrpPrice;
    }
  }

  @Input() specialPrice: any;

  @Input() product: any;

  @Input() price: any;

  @Input() discountPercentage: any;

  @Input() units: any;

  @Input() data: any;

  @Input() AmountType: any;



  formatIndianCurrency(value: number): string {
    if (!value) {
      return '';
    }

    if (value >= 10000000) {
      return ' Cr';
    } else if (value >= 100000) {
      return ' Lakh';
    } else {
      
    }
  }
}
